// @vendor
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
const { connect } = require('react-redux');

// @components
const {
  HireCardImageSelector,
} = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @actions
import { setWizardButtonStateByButton } from 'actions/okWizard';

// @utils
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;
const { recordPage } = require('utilities/tagging');

// @ constants
const { analyticsId, catalogue } = require('../analytics/hireSolidarityCardAnalytics');

export class HireSelectCardImage extends Component {
  componentDidMount() {
    this.props.onSetAsCurrentStep(this.validate);
    recordPage(catalogue[analyticsId.SOLIDARITY_CARD_STEP_3_VIEW]({ productName: this.props.processDetail }));
  }

  componentWillUnmount() {
    this.props.localSetWizardButtonStateByButton('next', {
      loading: false,
      disabled: false,
    });
  }

  validate = () => {
    return {
      isValid: true,
      imageSelected: this.props.imageSelected,
    };
  };

  render() {
    const { cardImageIds, immHireCardImageSelector, immHireCardNameSelector } = this.props;
    return (
      <Fragment>
        <FormattedText
          className="contract-view__wizard__title"
          value="hireCardRevolving-step2Title"
        />
        <HireCardImageSelector
          reverseOrderCards={true}
          cardImageIds={cardImageIds}
          immHireCardImageSelector={immHireCardImageSelector}
          hireCardImagesUpdateSelectedId={() => {}}
        />
        <HireCardNameSelector borderTop={true} immHireCardNameSelector={immHireCardNameSelector} />
      </Fragment>
    );
  }
}

HireSelectCardImage.propTypes = {
  onSetAsCurrentStep: PropTypes.func.isRequired,
  immHireCardImageSelector: PropTypes.object.isRequired,
  immHireCardNameSelector: PropTypes.object.isRequired,
  imageSelected: PropTypes.string.isRequired,
  cardImageIds: PropTypes.array.isRequired,
  localSetWizardButtonStateByButton: PropTypes.func.isRequired,
  processDetail: PropTypes.string,
};

module.exports.HireSelectCardImage = connect(
  state => ({
    immHireCardImageSelector: state.hireCardImageSelector,
    immHireCardNameSelector: state.hireCardNameSelector,
    imageSelected: state.hireCardImageSelector.get('selectedImageId'),
  }),
  {
    localSetWizardButtonStateByButton: setWizardButtonStateByButton,
  }
)(HireSelectCardImage);
